import {gql} from "@apollo/client";

export const GET_IPS_VIOLATION_POINTS = gql`
  query getIPSViolationPoints {
  getIPSViolationPoints {
    violationId
    violationType {
      type
      name
    }
    analyte {
      name
      code
    }
    analyteGroup {
      name
      code
      analytes {
        name
        code
      }
    }
    ruleReference
    ipsPoints
    returnToComplianceMethod
    lastUpdatedDate
  }
}
`;